export default __webpack_public_path__ + "static/media/flag-uk.c61e235a.svg";